import { memo } from 'react';

import MicrosoftOneDriveIcon from '@/assets/microsoft-one-drive-logo.svg?react';
import { Logo, LogoProps } from '@/components/core';

export type MicrosoftOneDriveLogoProps = LogoProps;

const IMicrosoftOneDriveLogo = ({ className, ...rest }: MicrosoftOneDriveLogoProps) => {
  return (
    <Logo className={className} {...rest}>
      <MicrosoftOneDriveIcon />
    </Logo>
  );
};

export const MicrosoftOneDriveLogo = memo(IMicrosoftOneDriveLogo) as typeof IMicrosoftOneDriveLogo;
